import { Box } from 'components/Box'
import { Icon } from 'components/Icon'
import { styled } from 'stitches.config'

export const CheckboxIcon = styled(Icon, {
  pointerEvents: 'none',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '$surface-100',
  opacity: 0,
})

export const CheckboxInput = styled('input', {
  appearance: 'none',
  border: '1px solid $accent-black',
  borderRadius: '$1',
  margin: 0,

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '$tertiary-100',
  },
  '&:active': {
    backgroundColor: '$tertiary-400',
  },
  '&:checked': {
    [`& + ${CheckboxIcon}`]: {
      size: '100%',
      opacity: 1,
      color: '$accent-white',
    },
  },
  '&:disabled': {
    cursor: 'not-allowed',
    border: '1px solid $accent-gray',
  },
  variants: {
    variant: {
      primary: {
        '&:checked': {
          backgroundColor: '$accent-black',
        },
      },
      secondary: {
        border: '1px solid $tertiary-300',
        '&:checked': {
          border: '1px solid $tertiary-400',
          backgroundColor: '$tertiary-400 !important',
        },
      },
      primaryRed: {
        border: '1px solid $accent-black',
        '&:checked': {
          border: '1px solid $primary-500',
          backgroundColor: '$primary-500 !important',
        },
      },
      unavailable: {
        border: '1px solid $accent-gray',
        '&:checked': {
          backgroundColor: '$accent-gray',
          border: '1px solid $accent-gray',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
})

export const CheckboxContainer = styled(Box, {
  display: 'inline-block',
  position: 'relative',
  size: '$2',
  marginRight: '$1',

  variants: {
    size: {
      small: {
        size: '$1',
      },
      medium: {
        size: '$3',
      },
      large: {
        size: '$4',
      },
      '24': {
        minHeight: '24px',
        minWidth: '24px',
        marginRight: '$2',
      },
    },
  },

  '&': {
    [`${CheckboxInput}`]: {
      size: '100%',
    },
  },
})

export const CheckboxRoot = styled('div', {
  display: 'flex',
  alignItems: 'center',
  color: '$accent-black',
  lineHeight: '$headline',
  fontSize: '$headline',

  '& input': {
    marginBottom: '$1',
  },

  label: {
    width: 'fit-content',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  variants: {
    variant: {
      primary: {
        [`& ${CheckboxInput}`]: {
          '&:checked': {
            backgroundColor: '$primary-500',
            border: '1px solid $primary-500',
          },
        },
      },
      secondary: {
        [`& ${CheckboxInput}`]: {
          border: '1px solid $tertiary-300',
          '&:checked': {
            border: '1px solid $tertiary-400',
            backgroundColor: '$tertiary-400',
          },
        },
      },
      primaryRed: {
        [`& ${CheckboxInput}`]: {
          border: '1px solid $tertiary-300',
          '&:checked': {
            border: '1px solid $accent-red',
            backgroundColor: '$accent-red',
          },
        },
      },
      unavailable: {
        color: '$accent-gray',
        [`& ${CheckboxInput}`]: {
          border: '1px solid $accent-gray',
          '&:checked': {
            border: '1px solid $accent-gray',
            backgroundColor: '$accent-gray',
          },
        },
      },
    },
    disabled: {
      true: {
        color: '$tertiary-400',
      },
    },
  },

  defaultVariants: {
    variant: 'primary',
  },
})

export const CheckboxLabelIcon = styled('div', {
  marginRight: '$1',
  variants: {
    size: {
      small: {
        size: '$4',
      },
      medium: {
        size: '$6',
      },
      large: {
        size: '$8',
      },
    },
  },
})
